import { SessionStorageFacade } from '../../../../facades/storage/sessionStorageFacade';

const STORAGE_VERSION = 'v1';
const STORAGE_KEY = `coop:bonusBanner:${STORAGE_VERSION}`;
const UNSUPPORTED_CRYPTO_DUMMY_HASH = 'unsupported-crypto';
const hashCache = new Map<string, string>();

export type BonusBannerShownEntry = {
    userId: string;
    isClosed: boolean;
};

// Lets hash userid so we dont store PII in local storage, even though its only userId.
const hashUserId = async (userId: string) => {
    const cachedHash = hashCache.get(userId);
    if (cachedHash) return cachedHash;

    const supportsCrypto = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined';

    if (!supportsCrypto) {
        return UNSUPPORTED_CRYPTO_DUMMY_HASH;
    }

    const bytes = new TextEncoder().encode(userId);
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    const hashedUserId = Array.from(new Uint8Array(digest))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');

    hashCache.set(userId, hashedUserId);
    return hashedUserId;
};

const getSessionKey = async (userId: string) => {
    const hashedUserId = await hashUserId(userId);

    return `${STORAGE_KEY}:${hashedUserId}`;
};

const bonusBannerStorage = {
    get: async (userId?: string) => {
        if (!userId) {
            return null;
        }

        const sessionKey = await getSessionKey(userId);

        return SessionStorageFacade.instance.getObject<BonusBannerShownEntry>(sessionKey);
    },
    add: async (entries: BonusBannerShownEntry) => {
        const sessionKey = await getSessionKey(entries.userId);

        SessionStorageFacade.instance.addObject(sessionKey, entries);
    },
    remove: async (entries: BonusBannerShownEntry) => {
        const sessionKey = await getSessionKey(entries.userId);

        SessionStorageFacade.instance.remove(sessionKey);
    },
};

export default bonusBannerStorage;
